import { logError } from "@faire/web--source/common/logging";
export var hCaptchaQueryKey = function(widgetID) {
    return [
        "hcaptcha-token",
        widgetID
    ];
};
export var logHCaptchaError = function(error, type) {
    return logError(error, {
        tags: {
            source: "hCaptcha",
            type: type
        }
    });
};
